<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
      <v-row align="center" justify="start" class="mt-15">
        <v-col cols="12" sm="8" md="6" lg="5" xl="6">
          <div class="mw-400">
            <v-skeleton-loader type="list-item-avatar, list-item-three-line, list-item-three-line, list-item-three-line, list-item-three-line" class="mb-3"></v-skeleton-loader>
          </div>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        Chamados
      </div>
      <v-row align="center" justify="start" class="mt-15">
        <v-col cols="12" sm="8" md="6" lg="5" xl="6">
          <div class="mw-400">
            <v-text-field
              class="mb-1"
              outlined
              type="numeric"
              label="Tempo de SLA"
              hint="Iformar em horas, ex: 12"
              v-model="form.cch_sla"
              :loading="salvando"
              :disabled="salvando"
            ></v-text-field>
            <v-text-field
              class="mb-4"
              hide-details
              outlined
              v-model="form.cch_os_api_url"
              :loading="salvando"
              :disabled="salvando"
              label="URL"
            ></v-text-field>
            <v-text-field
              class="mb-4"
              hide-details
              outlined
              v-model="form.cch_os_api_key"
              :loading="salvando"
              :disabled="salvando"
              label="Chave"
            ></v-text-field>
            <div class="text-right">
              <v-btn color="primary" @click="updateData()" :loading="salvando" :disabled="salvando" class="mb-4">Salvar</v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import Api from '@API'
export default {
  data () {
    return {
      loading: true,
      user: '',
      salvando: false,
      form: {
        uuid_cch_id: '',
        uuid_dis_id: '',
        cch_sla: '',
        cch_os_api_url: '',
        cch_os_api_key: ''
      }
    }
  },
  methods: {
    loadFunctions () {
      this.getDados()
    },
    async getDados () {
      this.user = JSON.parse(localStorage.getItem('user'))
      this.loading = true
      let dados = {
        uuid_dis_id: this.user.uuid_dis_id ? this.user.uuid_dis_id : '',
        uuid_int_id: this.user.uuid_int_id ? this.user.uuid_int_id : ''
      }
      await Api.post('configuracao/chamados', dados)
        .then(res => {
          this.form = res.data
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados!',
            color: 'error'
          })
          console.log(err)
        })
    },
    updateData () {
      this.salvando = true
      Api.post('configuracao/chamados/atualiza', this.form)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: 'Dadoas atualizados com sucesso!',
            color: 'success'
          })
          this.closeDialog()
          this.getIntegradores()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    }
  },
  created () {
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.mw-400 {
  max-width: 400px;
}
.ui-btn-inherit {
  margin-bottom: 3px!important;
  min-height: 10px!important;
}
.mw_img {
  max-width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/pages/configuracoes/Chamados.vue